import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { WebhooksQueryKeys } from "modules/WebhooksDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { WEBHOOK_TRIGGERS, WebhookHeader } from "models";

export type EditWebhookPayload = {
  id: number;
  url: string;
  name: string;
  active: boolean;
  queued: boolean;
  headers?: WebhookHeader[];
  checklist_id: number | null;
  dealer_location_id: number | null;
  webhook_trigger_id: WEBHOOK_TRIGGERS;
  block_creating_support_ticket: boolean;
};

export const useEditWebhookMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: EditWebhookPayload) => (await ApiInstance.post(`/webhooks/update`, payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const previousWebhooks = typedQueryClient.getQueryData(WebhooksQueryKeys.webhooks);
      if (!previousWebhooks) return;

      const editWebhookIdx = previousWebhooks.findIndex(webhook => webhook.id === payload.id);
      if (editWebhookIdx === -1) return;

      typedQueryClient.setQueryData(WebhooksQueryKeys.webhooks, [...previousWebhooks.with(editWebhookIdx, { ...previousWebhooks[editWebhookIdx], ...payload })]);
    }
  });
